<router-outlet></router-outlet>
<ngx-spinner>
  <div style="color: #eee">{{utilService.spinnerText || 'Loading...'}}</div>
</ngx-spinner>
